export default [
  {
    path: '/coupon/add',
    name: 'Coupon.Add',
    component: () =>
      import(
        '@/views/Coupon/Form.vue'
      ),
    meta: {
      title: 'Tambah Coupon',
      icon: 'fas fa-shopping-cart fa-2x'
    },
  },
  {
    path: '/coupon/:id/edit',
    name: 'Coupon.Edit',
    component: () =>
      import(
        '@/views/Coupon/Form.vue'
      ),
    meta: {
      title: 'Edit Coupon',
      icon: 'fas fa-shopping-cart fa-2x'
    },
  },
]
